import Global from '../../global';
import { eEnvironments } from '../../utils/enums';

export function getFavoritesConfig(useProdApis = false) {
  const env = Global.config.environment;
  const favoritesConfig = require(`./favorites.${
    useProdApis ? eEnvironments.prod : env
  }.js`).default;

  return favoritesConfig;
}

export function getFavoritesEndpoint(useProdApis = false) {
  const favoritesConfig = getFavoritesConfig(useProdApis);
  return favoritesConfig && favoritesConfig.endpoint;
}